import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  label: {
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '0.65rem',
    fontWeight: 'bold',
    letterSpacing: 0.5,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  value: {
    fontWeight: 'bold',
    overflow: 'hidden',
    lineHeight: '24px',
    wordBreak: 'break-word',
  },
}));

const Field = ({ label, value }: { label: string; value?: string }) => {
  const classes = useStyles();
  if (!value) return null;
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" className={classes.label}>
        {label}
      </Typography>
      <Typography variant="body2" className={classes.value}>
        {value}
      </Typography>
    </Grid>
  );
};

export const KarcherUserIdCard = () => {
  const { entity } = useEntity();
  const ann = entity.metadata.annotations;
  const karcherId = ann?.['karcher.com/employee-id'];

  if (!karcherId) {
    return null;
  }

  return (
    <InfoCard title="Kärcher Identity">
      <Grid container spacing={2}>
        <Field label="Employee ID" value={karcherId} />
        <Field label="Email" value={ann?.['karcher.com/employee-email']} />
        <Field label="Company" value={ann?.['karcher.com/company']} />
        <Field label="Company Code" value={ann?.['karcher.com/company-code']} />
        <Field label="Department" value={ann?.['karcher.com/department']} />
        <Field label="Site" value={ann?.['karcher.com/site']} />
        <Field label="Country" value={ann?.['karcher.com/country-code']} />
      </Grid>
    </InfoCard>
  );
};
